export default {
    setup: '5e1d0285-79b6-4d99-ade6-84cc9fbf32fb',
    setup_role: '9d254493-df8f-4f4d-be22-8401433dfd25',
    setup_role_add: 'a518315f-c4fb-480c-b710-d9a320378c6a',
    setup_role_edit: 'd96fa055-1261-46c9-b58c-e35adcf4da1a',
    setup_role_delete: 'e05c3fa9-44c6-4144-866d-8850c663615b',
    setup_role_view: 'fcd957f0-2f3c-43d9-8bfa-fe9d602703a4',
    setup_role_assign_permission: '7f9c9dbd-d520-4a19-a036-ae8b76bd7e6e',
    setup_role_update_hierarchy: '75e632bb-43c1-49c2-977b-268e387eefbd',
    setup_user: '41a48d08-4d13-4cd8-bb74-3e383a2fbaf8',
    setup_user_add: '03c3c561-a254-4d8b-a3d3-6fba76c3e36e',
    setup_user_edit: 'bc9c4a48-72bb-4ea5-bae2-c8af7c367e85',
    setup_user_delete: '81c28771-7efc-4691-b10b-36d2b35eaf29',
    setup_user_view: '0a3773d3-5450-4f00-a7d0-adb3c1f51309',
    setup_user_reset_password: '3566c134-44ce-4f5f-8ae5-df17b99a9be0',
    setup_user_mock_login: 'c519611d-0e8a-4321-a9c9-57c4a0bc0c40',
    location: '095e27a5-cf71-43b7-b093-30f5c5d460df',
    location_state: '5cc07ccf-65dc-41fc-8377-e5b99be511b2',
    location_district: 'a56512d5-d25a-406e-92fb-9854497fd5e0',
    location_taluka: '8558c82a-e30b-430e-a571-afe69f347abc',
    location_city: 'e2bc7d47-13dc-428e-9ee8-92dad00269d5',
    dashboard: 'ec003fe9-4cbe-4728-885d-9ec893917a1d',
    master: '9e629114-12c7-44eb-b3b3-26d1c204838b',
    master_category: '205054ae-548f-4d64-95b6-12f1636ab77d',
    master_category_item_category: 'c0453e39-3022-4f43-be93-a7b0bc8f55c1',
    master_category_material: '1f27f019-3d35-4cde-b24a-1ee64eeb0da3',
    master_subcategory: '7a6d8122-d7d5-4a2e-a4f7-07f962785f74',
    master_subcategory_item: '7403bf15-9cce-4279-ae36-147ad20716ce',
    master_subcategory_material_subcategory: 'ae268b5d-03b8-44f9-822c-a1d2dd0b256e',
    master_brand: 'd4762007-9488-44de-9dc5-3654b86ee748',
    master_unit: '481fd37d-d899-4fd5-8418-84ddf913f946',
    master_supplier: '3b37b399-ae56-47c2-ab11-b3abba529d3b',
    master_item: 'f1df7786-6bd4-49d0-ace7-6ca4c018bc60',
    master_material: 'a016fd91-3556-4122-b5f3-45dfbd1bb387',
    master_road_type: '7d1bf5a0-a299-47c9-aa91-84a81b010052',
    master_department: '22f1196e-117a-4caf-8082-c81dce44854b',
    master_designation: '149565d8-a523-42d1-83b3-95b761b9340b',
    mix_design: '047365c7-472b-4af2-8ce5-cc1ddc910eff',
    settings: '1c02545c-7628-4393-ad5b-7e86cbb87264',
    settings_project: '34f5964b-5cbc-4e98-a8c1-ee42556092cd',
    settings_menu_order: '2519d035-2b86-41ad-adf9-cb1edb0bfbda',
    settings_email_template: '38277437-1abd-4a6a-8d39-1840ee0f1707',
    settings_configuration: '404c6160-c25c-4ebc-bd43-1ce7c6f753f3',
    settings_module: 'd76431a3-fc51-4753-a4a5-87b5397affbb',
    agency: 'fff9cd88-f1a7-44ae-add9-abfb198fcf3b',
    project_owner: 'ae7b832a-e436-472b-be00-a802130df180',
    project: '83b38446-1830-4f0f-a081-f2e5b276043f',
    app_user: '9bd2f1e6-475f-4154-850d-4ceb77373d6c',
    stock_in: '5c5152fd-b3c2-480a-a387-a26d4ff3ee3b',
    audit_logs: '6b85144d-a728-4739-b4f0-b03299d737cd'
};
